import { render, staticRenderFns } from "./FlowAttr.vue?vue&type=template&id=155d76d0"
import script from "./FlowAttr.vue?vue&type=script&lang=js"
export * from "./FlowAttr.vue?vue&type=script&lang=js"
import style0 from "./FlowAttr.vue?vue&type=style&index=0&id=155d76d0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155d76d0')) {
      api.createRecord('155d76d0', component.options)
    } else {
      api.reload('155d76d0', component.options)
    }
    module.hot.accept("./FlowAttr.vue?vue&type=template&id=155d76d0", function () {
      api.rerender('155d76d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreatedFlow/modules/FlowAttr.vue"
export default component.exports